<template>
  <div>
    <q-select dense outlined v-model="mySearchData.field" @update:model-value="changeField" :options="fieldArr" emit-value map-options class="inb l mr10" style="width:100px;" >
      <q-tooltip anchor="top middle" self="bottom middle">查询项</q-tooltip>
    </q-select>
    <q-select dense outlined v-model="mySearchData.condition" :options="conditionArr" emit-value map-options class="inb l mr10" style="width:80px;" >
      <q-tooltip anchor="top middle" self="bottom middle">条件</q-tooltip>
    </q-select>
    <q-input class="w180 l mr10" outlined v-if="myType == 'input'"  v-model="mySearchData.value" dense square clearable>
    </q-input>
    <q-input class="w180 l mr10" outlined v-else-if="myType == 'date'"  v-model="mySearchData.value" dense square>
      <q-popup-proxy transition-show="scale" transition-hide="scale">
        <q-date v-model="mySearchData.value" mask="YYYY-MM-DD"></q-date>
      </q-popup-proxy>
    </q-input>
    <q-select class="w180 l mr10" v-if="myType == 'select'" clearable dense outlined v-model="mySearchData.value" :options="myOptions" emit-value map-options>
    </q-select>
    <q-input v-if="myType == 'dateRange'" class="l mr10 inb w180" outlined v-model="mySearchData.showValue" @update:model-value="showValueChange" dense square clearable>
      <q-popup-proxy  transition-show="scale" transition-hide="scale">
        <q-date v-model="mySearchData.value" range mask="YYYY-MM-DD" @update:model-value="dateRangeChange">
        </q-date>
      </q-popup-proxy>
    </q-input>
  </div>
</template>

<script>
import {computed, nextTick, onMounted, ref, toRef, watch} from "vue";
import {isNotEmpty,getDateInfo} from "@/tools/utils";
export default {
  name: "search-item",
  props:['searchData','columns','valueSet'],
  setup(props,context){
    let mySearchData = toRef(props.searchData);
    let fieldArr = computed(()=>{
      return props.columns.map(item=>{
        return {
          label: item.label, value: item.field
        }
      })
    });
    let myType = computed(()=>{
      let obj = props.columns.find(item=>{
        return item.field == props.searchData.field
      });
      return obj?.type ? obj.type : 'input';
    });
    let myOptions = computed(()=>{
      if(isNotEmpty(props.valueSet) && isNotEmpty(props.valueSet[props.searchData.field])){
        return props.valueSet[props.searchData.field]
      }
      return []
    })
    let nowCol = computed(()=>{
      let obj = props.columns.find(item=>{
        return item.field == props.searchData.field
      });
      return isNotEmpty(obj) ? obj :{};
    });
    let conditionArr = ref([
      {label:'等于',value:'='},
      {label:'大于',value:'>'},
      {label:'小于',value:'<'},
      {label:'大于等于',value:'>='},
      {label:'小于等于',value:'<='},
    ]);
    function showValueChange(value){
      if(!isNotEmpty(value)){
        mySearchData.value.value.from = '';
        mySearchData.value.value.to = '';
      }
    }
    function dateRangeChange(value){
      if(typeof value == 'string'){
        mySearchData.value.showValue = value;
      }else{
        mySearchData.value.showValue = value.from+'-'+value.to;
      }
    }
    function changeField(){
      mySearchData.value.value = '';
      nextTick(()=>{
        context.emit('resetSearchArr');
      })
    }
    return{
      mySearchData,
      fieldArr,
      conditionArr,
      myType,
      nowCol,
      myOptions,
      changeField,
      dateRangeChange,
      showValueChange
    }
  }
}
</script>

<style scoped>

</style>
